<template>
  <v-app style="background: white">
    <transition name="fadeIn">
      <Cart
        v-if="loadingPage"
        v-on:closeCart="cartIsOpened = !cartIsOpened"
        class="cart-main"
        v-show="cartIsOpened"
        id="cart_view"
      ></Cart>
    </transition>
    <!--CART SIDE BAR-->
    <!--Issue here-->
    <cart-side-bar :mouseState="mouseOnCartBtn" />
    <!--SIDE NAVBAR-->
    <side-navbar />
    <!--HORIZONTAL NAVBAR-->
    <horizontal-navbar
      v-on:showCart="openCart"
      v-on:mouse-on-cart="mouseOnCartBtn = true"
      v-on:mouse-leave-from-cart="mouseOnCartBtn = false"
    />
    <!-- App Content -->
    <main v-if="loadingPage">
      <v-container class="mt-4">
        <v-layout row>
          <v-dialog v-model="loading" persistent fullscreen>
            <v-container fill-height>
              <v-layout column justify-center align-center>
                <v-progress-circular
                  indeterminate
                  :size="50"
                  :width="10"
                  color="secondary"
                ></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-layout>
        <transition name="fade">
          <router-view />
        </transition>
        <!--FOOTER-->
        <Footer />
        <!--AUTH SNACKBAR-->
        <auth-snackbar />
      </v-container>
    </main>
  </v-app>
</template>

<script>
import Footer from "./components/shared/Footer.vue";
import Cart from "./components/shop/Cart";
import HorizontalNavbar from "./components/common/HorizontalNavbar";
import SideNavbar from "./components/common/SideNavbar";
import CartSideBar from "./components/common/CartSideBar";
import AuthSnackbar from "./components/common/AuthSnackbar";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Footer,
    Cart,
    HorizontalNavbar,
    SideNavbar,
    AuthSnackbar,
    CartSideBar
  },
  data() {
    return {
      cartIsOpened: false,
      mouseOnCartBtn: false,
      loadingPage: false
    };
  },
  created() {
    this.handleGetCategoryList();
    //this.allowedClubs = this.getAllowedClubs();
  },
  computed: {
    ...mapGetters(["loading", "user", "cart"])
  },
  methods: {
    // replaceSpaces: function( item ) {
    //         return item.split(' ').join('_');
    // },
    openCart() {
      this.cartIsOpened = true;
    },
    handleGetClubsList() {
      //reach out of Vuex store, fire action that gets Clubs
      this.$store.dispatch("allClubs", {});
    },
    handleGetCategoryList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allCategory", {});
    }
  },
  beforeMount() {
    this.$store.dispatch("allProducts").then((this.loadingPage = true));
  },
  mounted() {}
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}
.fade-enter-active {
  transition-delay: 0.25s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-25px);
}

/* fade in transition */

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition-property: all;
  transition-duration: 0.4s;
}
.fadeIn-enter-active {
  transition-delay: 0.25s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
  transform: translateY(-200px);
}

.cart-main {
  position: fixed;
  z-index: 1001;
  width: 100%;
  background: white;
}
</style>
